export const createClientVisitor = (
  visitorId = null,
  authenticated,
  deviceType,
  searchParams = '',
  pagePath = '/',
) => {
  if (visitorId) visitorId += '';
  return {
    id: visitorId,
    context: {
      deviceType: String(deviceType),
      queryParameters: searchParams,
      pagePath: pagePath,
    },
    isAuthenticated: authenticated,
  };
};
